/* eslint-disable no-shadow */
export enum WhitelistTypeEnum {
	curp = 'CURP',
	folio = 'FOLIO',
}

export const WhitelistTypeValues: Record<WhitelistTypeEnum, string> = {
	[WhitelistTypeEnum.curp]: 'CURP',
	[WhitelistTypeEnum.folio]: 'FOLIO',
};

export enum WhitelistNameEnum {
	creditLine = 'Credit Line',
	payJoyEmployees = 'Empleados PayJoy',
	abandonedCart = 'Carritos abandonados',
}

export const WhitelistNameValues: Record<string, string> = {
	// [WhitelistNameEnum.creditLine]: 'Credit Line',
	[WhitelistNameEnum.payJoyEmployees]: 'Empleados PayJoy',
	[WhitelistNameEnum.abandonedCart]: 'Carritos abandonados',
};

export interface WhitelistEntry {
	_id: string;
	name: WhitelistNameEnum;
	type: WhitelistTypeEnum;
	value: string;
	expiresAt: string | null;
	isActive: boolean;
	createdAt: string;
	updatedAt: string;
}

export interface ListWhitelistFilters {
	type?: WhitelistTypeEnum;
	name?: WhitelistNameEnum;
	value?: string;
	vigente?: boolean;
	isActive?: boolean;
	page?: number;
	limit?: number;
	sort?: string;
}

export interface BatchUploadResult {
	total: number;
	created: number;
	updated: number;
}

export interface UpdateWhitelistEntryFields {
	name?: WhitelistNameEnum;
	expiresAt?: string | null;
	isActive?: boolean;
}
